let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("72vCF")).then(() => parcelRequire('g4C2O'));